<template>
  <div class="register_body">
    <div class="register">
      <div class="img">
        <img src="@/assets/icon_top_logo.png">
      </div>
      <div class="nav_item_out">
        <div class="nav_item" @click="goSwitchLogin(0)">
          <span :class="currentIndex==0?'color_dark_green':'color_black'">账号注册</span>
          <div :class="currentIndex==0?'line':'line_white'"></div>
        </div>
        <div class="nav_item" @click="goSwitchLogin(2)">
          <span :class="currentIndex==2?'color_dark_green':'color_black'">账号登录</span>
          <div :class="currentIndex==2?'line':'line_white'"></div>
        </div>
      </div>
      <div  style="margin-top:30px;">
        <el-input placeholder="手机号码" v-model="mobile" clearable size="medium"></el-input>
      </div>
      <div  style="margin-top:10px;">
        <el-input placeholder="登录密码" v-model="password" show-password size="medium"></el-input>
      </div>
      <!-- <div v-if="currentIndex !== 2" style="margin-top:10px;">
        <el-input placeholder="昵称" v-model="nickname"  size="medium"></el-input>
      </div> -->
      <div v-if="currentIndex !== 2" style="margin-top:10px;">
        <el-input placeholder="确认密码" v-model="repassword"  show-password size="medium"></el-input>
      </div>
      <!-- <div v-if="currentIndex !== 2" style="margin-top:10px;">
        <el-select v-model="shenfen" placeholder="身份(选填)" size="medium">
          <el-option
            v-for="item in  shenfenOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
            class="simes"
          ></el-option>
        </el-select>
      </div>
      <div v-if="currentIndex !== 2" style="margin-top:10px;">
        <el-select v-model="workunit" placeholder="工作单位(选填)" size="medium">
          <el-option
            v-for="item in workOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
            class="simes"
          ></el-option>
        </el-select>
      </div>
      <div v-if="currentIndex !== 2" style="margin-top:10px;">
        <el-input placeholder="邮箱地址(选填)" v-model="email" clearable size="medium"></el-input>
      </div> -->
      <!-- 验证码 -->
      <div class="code_box" v-if="currentIndex !== 2">
        <el-input placeholder="验证码" v-model="code" clearable size="medium"></el-input>
        <el-button type="primary" size="mini" style="margin-left: 10px;" @click="getCode">{{ codeText }}</el-button>
      </div>

      <div  style="margin-top:10px;">
        <el-checkbox v-model="checked">我同意 <span style="color: #3c9c8f;" @click="openProtocol('user')">《用户服务协议》</span> 和 <span style="color: #3c9c8f;" @click="openProtocol('privacy')">《隐私服务协议》</span></el-checkbox>
      </div>
      <div class="register_btn" @click="currentIndex === 2 ? login() : register()"> 
         {{ currentIndex === 2 ? '立即登录' : '立即注册' }}
      </div>
       <div class="has_lo" @click="currentIndex === 2?goSwitchLogin(0):goSwitchLogin(2)"> 
         {{ currentIndex === 2 ? '没有账号？立即注册' : '已有账号？立即登录' }}
      </div>
    </div>
    <el-dialog :visible.sync="showProtocol" width="50%">
      <div v-if="protocolType === 'user'" style="max-height: 500px; overflow-y: auto;">
        <div v-html="base.service_agreement"></div>
      </div>
      <div v-if="protocolType === 'privacy'" style="max-height: 500px; overflow-y: auto;" >
        <div v-html="base.privacy_agreement"></div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapMutations,mapGetters } from 'vuex';
export default {
  data() {
    return {
      currentIndex: 0,
      options: [],
      value: "",
      nickname: "",
      account: "",
      password: "",
      mobile: "",
      shenfen: "",
      workunit: "",
      email: "",
      checked: false,
      isSubmit: false,
      repassword: "",
      shenfenOptions: [],
      workOptions: [],
      showProtocol: false,
      protocolType: '',
      code: '',
      codeText: '获取验证码',
      codeTimer: null,
      codeTime: 60
    };
  },
  computed: {
    ...mapGetters(['base'])
  },
  watch: {
    base: {
      handler(newVal) {
        if(newVal.shenfen){
          this.shenfenOptions = newVal.shenfen.map(item => ({
            value: item,
            label: item
          }));
        }
        if(newVal.workunit){
          this.workOptions = newVal.workunit.map(item => ({
            value: item,
            label: item
          }));
        }
      },
      immediate: true
    }
  },
  methods: {
    ...mapMutations(['setUser']),
    async getCode() {
      if(!this.mobile){
        this.$message.error('请输入手机号码')
        return
      }
      try {
        const res = await this.$api.getCode({
          mobile: this.mobile,
          type: this.currentIndex===0?'register':'login'
        })
        if(res.code == 1){
          this.codeText = '获取验证码'
          this.codeTime = 60
          this.codeTimer = setInterval(() => {
            this.codeTime--
            if(this.codeTime <= 0){
              clearInterval(this.codeTimer)
              this.codeTimer = null
              this.codeText = '获取验证码'
            }else{
              this.codeText = `${this.codeTime}秒后获取`
            }
          }, 1000)
        }else{
          this.$message.error(res.message)
        }
      } catch (error) {
        this.$message.error(error.message)
      }
      
    },
    openProtocol(type) {
      this.showProtocol = true
      this.protocolType = type
    },
    goSwitchLogin(index) {
      this.currentIndex = index;
    },
    verifyForm(){
      // if(!this.nickname){
      //   this.$message.error('请输入昵称')
      //   return false
      // }
      // if(!this.account){
      //   this.$message.error('请输入用户名')
      //   return false
      // }
      if(!this.mobile){
        this.$message.error('请输入手机号码')
        return false
      }
      if(!this.password){
        this.$message.error('请输入密码')
        return false
      }
      if(!this.repassword){
        this.$message.error('请输入确认密码')
        return false
      }
      if(this.password !== this.repassword){
        this.$message.error('密码不一致')
        return false
      }
      // if(!this.shenfen){
      //   this.$message.error('请选择身份')
      //   return false
      // }
      // if(!this.workunit){
      //   this.$message.error('请选择工作单位')
      //   return false
      // }
      // if(!this.email){
      //   this.$message.error('请输入邮箱地址')
      //   return false
      // }
      if(!this.checked){
        this.$message.error('请同意用户协议和隐私政策')
        return false
      }
      return true
    },
  
    async register() {
      if(this.isSubmit){
        return
      }
      if(!this.verifyForm()){
        return
      }
      this.isSubmit = true
      this.nickname = this.account
      try{
        const res = await this.$api.register({
          account: this.account,
          nickname: this.nickname,
          mobile: this.mobile,
          password: this.password,
          repassword: this.repassword,
          shenfen: this.shenfen,
          workunit: this.workunit,
          email: this.email,
          code: this.code
        })
      if(res.code == 1){
        this.$message.success('注册成功')
        this.setUser(res.data)
        this.$router.push('/')
      }else{
        this.$message.error(res.message)
      }
      this.isSubmit = false
      }catch(err){
        this.$message.error(err.message)
        this.isSubmit = false
      }
    },
    async login() {
      if(this.isSubmit){
        return
      }
      if(!this.mobile){
        this.$message.error('请输入手机号码')
        return
      }
      if(!this.password){
        this.$message.error('请输入密码')
        return
      }
      if(!this.checked){
        this.$message.error('请同意用户协议和隐私政策')
        return
      }
      this.isSubmit = true
      try{
        const res = await this.$api.login({
          mobile: this.mobile,
          password: this.password,
          type: 1
        })
        if(res.code == 1){
          this.$message.success('登录成功')
          this.setUser(res.data)
          this.$router.push('/')
        }else{
          this.$message.error(res.message)
        }
        this.isSubmit = false
      }catch(err){
        this.$message.error(err.message)
        this.isSubmit = false
      }
    }
  }
};
</script>

<style lang="less" scoped>
.register_body {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding-top: 90px;
}
.img {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.register {
  width: 400px;
  background: white;
  margin-top: 5%;
  padding: 30px;
  margin-bottom: 5%
}
.nav_item_out {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-top: 40px;
}
.nav_item {
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.line {
  width: 40px;
  height: 3px;
  background: #3c9c8f;
  border-radius: 10px;
  margin-top: 10px;
}
.line_white {
  width: 30px;
  height: 2px;
  background: #ffffff;
  border-radius: 10px;
  margin-top: 10px;
}
.color_black {
  color: #000000;
  font-size: 20px;
  width: 100px;
  text-align: center;
}
.color_dark_green {
  font-size: 20px;
  color: #3c9c8f;
  width: 100px;
  text-align: center;
}
.register_btn{
  cursor: pointer;
    background: #3c9c8f;
    height: 40px;
    text-align: center;
    line-height: 40px;
    color: white;
    border-radius: 2px;
    margin-top: 15px;
}
.has_lo{
  cursor: pointer;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: flex-end;
    color: #777777;
    font-size: 14px;
    margin-top: 15px; 
}
.code_box {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
}
</style>
<style>
.el-input {
  background: #f7f7f7 !important; 
}
.el-input__inner {
  background: #f7f7f7 !important; 
}
.el-select {
  display: inline-block;
  position: relative;
  width: 100% !important;
}
</style>
